import React from 'react';
import { Card } from './ui/card';
import { Label } from './ui/label';
import { Input } from './ui/input';

const fmt = (v) => `${(v || 0).toLocaleString('pl-PL', { minimumFractionDigits: 2 })} zł`;

// Finance card for users who see only the offer value and their own commission (Handlowiec B2B)
export const OfferCommissionCard = ({ project, editing, formData, setFormData }) => (
  <Card className="bg-[var(--crm-bg-dialog)] border-[var(--crm-border)] p-6" data-testid="offer-commission-card">
    <h2 className="text-xl font-manrope font-semibold text-[var(--crm-text-primary)] mb-4">Wartość i prowizja</h2>
    {editing ? (
      <div>
        <Label className="text-[var(--crm-text-secondary)]">Całkowita Oferta (zł)</Label>
        <Input type="number" step="0.01" value={formData.total_offer} data-testid="offer-commission-total-input"
          onChange={(e) => setFormData({ ...formData, total_offer: e.target.value })}
          className="bg-[var(--crm-bg-panel)] border-[var(--crm-border)] text-[var(--crm-text-primary)] font-mono" />
      </div>
    ) : (
      <div className="space-y-3">
        <div className="flex justify-between items-center py-2">
          <span className="text-[var(--crm-text-secondary)]">Oferta</span>
          <span className="font-mono font-semibold text-[var(--crm-text-primary)]" data-testid="offer-commission-total">{fmt(project.total_offer)}</span>
        </div>
        <div className="flex justify-between items-center py-2 border-t border-[var(--crm-border)]">
          <span className="text-[var(--crm-text-secondary)]">
            Twoja prowizja ({project.commission_percent || 0}% od {project.commission_base === 'net_margin' ? 'marży netto' : 'wartości oferty'})
            {project.status === 'zakonczone' ? ' – naliczona' : ' – szacowana'}
          </span>
          <span className="font-mono font-semibold text-emerald-500" data-testid="offer-commission-amount">{fmt(project.commission_amount)}</span>
        </div>
      </div>
    )}
  </Card>
);

export default OfferCommissionCard;
